module.exports = __webpack_public_path__ + "img/budget.f52fcc5e.png";